export async function callAuthApi(token: string): Promise<Response> {
    return await fetch("/auth/callback", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({
            idToken: token,
        }),
    });
}